import React, { ReactNode } from 'react';

import HeaderLabel from '@totem/components/ui_components/headers/HeaderLabel';
import HeaderValue from '@totem/components/ui_components/headers/HeaderValue';
import { themeData } from '@totem/styles/theme';

const styles = {
  headerItem: {
    fontSize: themeData.token.fontSize,
    lineHeight: '1.5em',
  },
};

type Props = {
  title: ReactNode;
  children: ReactNode;
  titleStyle?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
};

const HeaderItem = ({ title, children, titleStyle, valueStyle }: Props) => {
  return (
    <div style={styles.headerItem}>
      <HeaderLabel style={titleStyle}>{title}</HeaderLabel>
      <HeaderValue style={valueStyle}>{children}</HeaderValue>
    </div>
  );
};

export default HeaderItem;
